import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/blockpage411/node_modules/next/dist/client/app-dir/link.js");
